<script>
  // @ts-check
  import { getTheme } from "../../utilities/themes";
  // @ts-ignore
  // eslint-disable-next-line no-unused-vars
  import * as Types from "./globalNavigationTypes";
  import { trapFocus } from "../../utilities/accessibility";

  import GlobalNavigationContent from "./GlobalNavigationDesktopContent.svelte";
  import GlobalNavigationBar from "./GlobalNavigationDesktopBar.svelte";
  import GlobalNavigationAnimationWrapper from "./GlobalNavigationAnimationWrapper.svelte";

  /** @type {import('../../utilities/themes.js').ThemeName} */
  export let theme = "white";

  /** @type {string}  Choose which one is the active route*/
  export let currentRoute;

  /** @type {Types.MainNavigation} */
  export let mainNavigation;

  /** @type {boolean}*/
  export let isHidden;

  /** @type {boolean}*/
  export let isExpanded;

  /** @type {string} */
  export let mainLogoAccessibilityText;

  /** @type {boolean}*/
  export let hasScrolledPastNav;

  /** @type {boolean}*/
  export let isSearchPanelVisible = false;

  /** @type {boolean}*/
  export let delayThemeFadeOnNavBar = false;

  /** @type {boolean}*/
  export let animateNavBarItems = false;

  let displayedSection = undefined;
  let isHoverActive = false;
  let collapseDisplayedSectionOnSearch = false;
  let contentOpen = false;

  $: {
    if (!isHoverActive && !!displayedSection) {
      isHoverActive = true;
    }
    if (isHidden && isHoverActive && hasScrolledPastNav) {
      displayedSection = undefined;
    }
    if (isSearchPanelVisible && !!displayedSection) {
      collapseDisplayedSectionOnSearch = true;
      displayedSection = undefined;
    }
    if (!isSearchPanelVisible) {
      collapseDisplayedSectionOnSearch = false;
    }
  }

  /** @type {import('../../utilities/themes').Theme}*/
  $: currentDesktopTheme = getTheme(theme);

  const handleHoveredLabel = (e) => {
    displayedSection = e.detail.displayedSection;
    isExpanded = true;
  };

  const handleHideSecondarySection = () => {
    displayedSection = undefined;
    isHoverActive = false;
    isExpanded = false;
  };

  $: if (!displayedSection && contentOpen) {
    contentOpen = false;
  }

  const handleOnIntroEnd = () => {
    contentOpen = true;
  };

  $: navVisibilityClasses = isHidden ? "-top-nav-height-desktop" : "top-0";
  $: navTransitionDelay = isExpanded || isSearchPanelVisible ? "delay-[2000ms]" : "";
</script>

<nav
  class="{hasScrolledPastNav || isExpanded
    ? currentDesktopTheme?.backgroundColor
    : 'bg-transparent'} {navVisibilityClasses} 
    cta-md sticky left-0 z-10 hidden h-nav-height-desktop w-full transition-all {navTransitionDelay} duration-[300ms] ease-nav-easing lg:block"
  on:mouseleave={handleHideSecondarySection}
  use:trapFocus={{
    shouldTrapFocus: isSearchPanelVisible,
    triggerElementQuery: ""
  }}
>
  <GlobalNavigationBar
    {mainNavigation}
    {displayedSection}
    {currentRoute}
    {theme}
    {hasScrolledPastNav}
    on:hoveredLabel={handleHoveredLabel}
    on:searchClose
    {mainLogoAccessibilityText}
    {isSearchPanelVisible}
    {delayThemeFadeOnNavBar}
    {animateNavBarItems}
  >
    <svelte:fragment slot="utilityNavigation">
      <slot name="utilityNavigation" />
    </svelte:fragment>
  </GlobalNavigationBar>
  {#if displayedSection}
    <GlobalNavigationAnimationWrapper
      on:introEnd={handleOnIntroEnd}
      {theme}
      {collapseDisplayedSectionOnSearch}
    >
      <svelte:fragment slot="content">
        <GlobalNavigationContent {mainNavigation} {displayedSection} {theme} {contentOpen} />
      </svelte:fragment>
    </GlobalNavigationAnimationWrapper>
  {/if}
  {#if isSearchPanelVisible}
    <GlobalNavigationAnimationWrapper
      {isSearchPanelVisible}
      {theme}
      {collapseDisplayedSectionOnSearch}
    >
      <svelte:fragment slot="content">
        <slot name="searchPanel" />
      </svelte:fragment>
    </GlobalNavigationAnimationWrapper>
  {/if}
</nav>
